import { collect } from 'collect.js';
import { AppWebViewMessageTypes } from '../exports/Constants';

declare global {
  interface Window {
    ReactNativeWebView: {
      postMessage(data: string): void;
    };
  }
}

export default class WebViewResource {
  public static sendMessage(type: AppWebViewMessageTypes, payload: any): void {
    try {
      window.ReactNativeWebView.postMessage(collect({ type, payload }).toJson());
    } catch (error) {
      window.ReactNativeWebView && console.error('Failed to send message via webview communicator', error);
    }
  }

  public static sendMessageIf(condition: boolean, type: AppWebViewMessageTypes, payload: any): void {
    if (condition) {
      WebViewResource.sendMessage(type, payload);
    }
  }
}
